import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import useIsMobile from "@hooks/useIsMobile";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import { twMerge } from "tailwind-merge";
import MobileCarInfoV2 from "@/pages/checkout/components/HeadingSteps/MobileCarInfo/MobileCarInfoV2";
import HeadingSteps from "@/pages/checkout/shop-apply/shopApplyForm/HeadingSteps/HeadingSteps";
import PaymentInfo from "@/pages/checkout/components/PaymentInfo/PaymentInfo";
import TabbyInfoComponent from "@/pages/checkout/bnpl/tabby/components/TabbyInfoComponent";
import TabbyOTPStep from "@/pages/checkout/bnpl/tabby/components/TabbyOTPStep";
import { handleHasAccountEvent } from "@/utils/common";
import { useLang } from "@/common/Contexts/LanguageContext";
import useHelpers from "@hooks/useHelpers";
import { api__createTabbyCheckoutSession } from "@/pages/checkout/bnpl/tabby/api/tabbyApi";
import { serverUrl } from "@globalConfig";
import { useTabbyFinance } from "@/common/Contexts/TabbyFinanceContext";
import { trackEvents } from "@/common/events/events";
import { getPlatformInfo } from "@/utils/GlobalJavascriptFunction";
import { toast } from "sonner";
import WarrantySection from "@/pages/checkout/warranty/WarrantySection";
var TabbyFormContent = function TabbyFormContent(_ref) {
  var checkoutOrder = _ref.checkoutOrder,
    fetch_loading = _ref.fetch_loading,
    userInfo = _ref.userInfo,
    isOtpStep = _ref.isOtpStep,
    isOtpLoading = _ref.isOtpLoading,
    autosend = _ref.autosend,
    setIsOtpStep = _ref.setIsOtpStep,
    setIsOtpLoading = _ref.setIsOtpLoading,
    setAutoSend = _ref.setAutoSend,
    onInfoIconClick = _ref.onInfoIconClick,
    _ref$showCancelButton = _ref.showCancelButton,
    showCancelButton = _ref$showCancelButton === void 0 ? false : _ref$showCancelButton,
    onCancelButtonClick = _ref.onCancelButtonClick,
    onFormUpdated = _ref.onFormUpdated,
    onFormCompleted = _ref.onFormCompleted;
  var _useTranslation = useTranslation(["web_checkout_finance", "web_checkout_cash", "web_sell_trade"]),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var isMobile = useIsMobile();
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn;
  var lang = useLang();
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useTabbyFinance = useTabbyFinance(),
    tabbyActions = _useTabbyFinance.actions,
    remote_actions = _useTabbyFinance.remote_actions;
  var isDesktop = !isMobile;
  var handleOtpVerified = function handleOtpVerified(userData) {
    var _checkoutOrder$warran, _checkoutOrder$warran2;
    if (!isLoggedIn) {
      handleHasAccountEvent({
        hasAccount: userData.has_account,
        status: "Success",
        phone_number: userData === null || userData === void 0 ? void 0 : userData.phone_number,
        lang: lang,
        referral_location: "tabby_order"
      });
    }
    var post_id = (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_id) || 0;
    var selectedCity = String(userInfo.city_id || "1");
    var tabbyRequest = _objectSpread({
      post_id: post_id,
      first_name: (userInfo.first_name || "").trim(),
      last_name: (userInfo.family_name || "").trim(),
      phone_number: userInfo.mobile_number || "",
      city_id: parseInt(selectedCity),
      whatsapp_optin: userInfo.whatsapp_optin,
      success_url: "".concat(serverUrl, "/").concat(lang === "en" ? "en/" : "", "finance-apply-tabby/payment-success?post_id=").concat(post_id),
      failure_url: "".concat(serverUrl, "/").concat(lang === "en" ? "en/" : "", "finance-apply-tabby/payment-failed?post_id=").concat(post_id),
      cancel_url: "".concat(serverUrl, "/").concat(lang === "en" ? "en/" : "", "finance-apply-tabby/payment-cancel?post_id=").concat(post_id)
    }, (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$warran = checkoutOrder.warrantyV2) === null || _checkoutOrder$warran === void 0 ? void 0 : (_checkoutOrder$warran2 = _checkoutOrder$warran.selected) === null || _checkoutOrder$warran2 === void 0 ? void 0 : _checkoutOrder$warran2.id) != null && {
      v_warranty_id: checkoutOrder.warrantyV2.selected.id
    });
    if (setIsOtpLoading) setIsOtpLoading(true);
    api__createTabbyCheckoutSession(tabbyRequest).then(function (response) {
      var _response$data, _checkoutOrder$g4_dat, _checkoutOrder$g4_dat2, _checkoutOrder$g4_dat3, _checkoutOrder$g4_dat4, _checkoutOrder$g4_dat5, _checkoutOrder$g4_dat6, _checkoutOrder$g4_dat7, _response$data2;
      trackEvents("tabby_form_submit", {
        post_id: post_id,
        order_id: String(((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.order_id) || ""),
        user_city: userInfo.city_name || selectedCity,
        inventory_type: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$g4_dat = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat === void 0 ? void 0 : _checkoutOrder$g4_dat.inventory_type,
        post_make: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$g4_dat2 = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat2 === void 0 ? void 0 : _checkoutOrder$g4_dat2.post_make,
        post_model: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$g4_dat3 = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat3 === void 0 ? void 0 : _checkoutOrder$g4_dat3.post_model,
        post_trim: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$g4_dat4 = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat4 === void 0 ? void 0 : _checkoutOrder$g4_dat4.post_ext,
        post_year: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$g4_dat5 = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat5 === void 0 ? void 0 : _checkoutOrder$g4_dat5.post_year,
        post_condition: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$g4_dat6 = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat6 === void 0 ? void 0 : _checkoutOrder$g4_dat6.post_condition,
        post_price: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$g4_dat7 = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat7 === void 0 ? void 0 : _checkoutOrder$g4_dat7.post_price,
        total_amount: checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.total_price ? parseFloat(checkoutOrder.total_price.replace(/,/g, "")) : undefined,
        platform: getPlatformInfo(),
        referral_location: "pre-checkout"
      });
      if (response.success && (_response$data2 = response.data) !== null && _response$data2 !== void 0 && _response$data2.checkout_url) {
        var _response$data3;
        tabbyActions === null || tabbyActions === void 0 ? void 0 : tabbyActions.action__updateUserInfo({
          first_name: userInfo.first_name,
          family_name: userInfo.family_name,
          mobile_number: userInfo.mobile_number,
          city_id: selectedCity,
          city_name: userInfo.city_name || null,
          whatsapp_optin: userInfo.whatsapp_optin,
          order_id: String(((_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.order_id) || "")
        });
        onFormCompleted === null || onFormCompleted === void 0 ? void 0 : onFormCompleted();
        window.location.href = response.data.checkout_url;
      } else {
        var _response$data4, _response$data5, _response$data6;
        if ((response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.rejection_reason) === "order_amount_too_high") {
          navigateTo("/finance-apply-tabby/payment-cancel-exceeds-limit?post_id=".concat(post_id));
        } else if ((response === null || response === void 0 ? void 0 : (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : _response$data5.rejection_reason) === "order_amount_too_low") {
          navigateTo("/finance-apply-tabby/payment-cancel-low-limit?post_id=".concat(post_id));
        } else if (response !== null && response !== void 0 && (_response$data6 = response.data) !== null && _response$data6 !== void 0 && _response$data6.rejection_reason) {
          navigateTo("/finance-apply-tabby/payment-failed?post_id=".concat(post_id));
        } else {
          toast.error(tShort("tamara/payment_session_error"));
        }
        if (setIsOtpLoading) setIsOtpLoading(false);
      }
    })["catch"](function (error) {
      console.error("Error creating Tabby checkout after OTP:", error);
      toast.error(tShort("tamara/connection_error"));
      if (setIsOtpLoading) setIsOtpLoading(false);
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "mx-auto !w-[80%] max-w-[1152px] max-lg:!w-[90%] after:content-[''] after:fixed after:bottom-0 after:left-0 after:w-full after:h-full after:z-[-1] after:bg-[#ffffff] sm:after:bg-[#fafcff] !mt-0 md:!mt-8 relative"
  }, showCancelButton && onCancelButtonClick && /*#__PURE__*/React.createElement("button", {
    className: "whtBtn w-[76px] h-8 flex items-center justify-center rounded border border-[#d6dfe9] cursor-pointer",
    onClick: onCancelButtonClick
  }, t("cancel", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("div", {
    className: twMerge("flex flex-col-reverse sm:flex-row items-start justify-between pb-10 mt-0", !isMobile && "gap-[22px] md:!mt-4")
  }, /*#__PURE__*/React.createElement("div", {
    className: twMerge("w-full relative sm:bg-white sm:min-w-[660px] sm:max-w-[660px] md:mx-auto", !isMobile && "border-none sm:rounded-xl sm:border sm:border-solid sm:border-[#EBF0F7] py-4 px-6")
  }, /*#__PURE__*/React.createElement(HeadingSteps, {
    className: isMobile && "pb-8"
  }, !isOtpLoading && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: "14px",
      paddingBottom: "4px"
    },
    className: isOtpStep ? "completed" : "active"
  }, t("add_information", {
    ns: "web_checkout_cash"
  }))), !isLoggedIn && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: "14px",
      paddingBottom: "4px"
    },
    className: isOtpStep ? "active" : ""
  }, t("verify_code", {
    ns: "web_sell_trade"
  }))), isMobile && !isOtpStep && /*#__PURE__*/React.createElement(MobileCarInfoV2, {
    className: "mt-5 mb-6",
    checkoutOrder: checkoutOrder,
    onClickInfoIcon: onInfoIconClick,
    hideData: true
  }), isMobile && !isOtpStep && /*#__PURE__*/React.createElement("div", {
    className: "mt-5"
  }, /*#__PURE__*/React.createElement(WarrantySection, {
    checkoutOrder: checkoutOrder,
    orderType: "tabby",
    referralLocation: "checkout",
    onWarrantyChange: function onWarrantyChange(id) {
      return void (remote_actions === null || remote_actions === void 0 ? void 0 : remote_actions.fetch__getOrderDetailsByParams({
        warranty_id: id,
        city_id: String((userInfo === null || userInfo === void 0 ? void 0 : userInfo.city_id) || "")
      }));
    }
  })), isOtpStep ? /*#__PURE__*/React.createElement(TabbyOTPStep, {
    userInfo: userInfo,
    onVerified: handleOtpVerified,
    post_id: (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_id) || 0,
    financestep: 1
  }) : /*#__PURE__*/React.createElement(TabbyInfoComponent, {
    autosend: autosend,
    setIsOtpStep: setIsOtpStep,
    onFormUpdated: onFormUpdated,
    onFormCompleted: onFormCompleted
  })), /*#__PURE__*/React.createElement("div", {
    id: "checkout-payment-container",
    className: "w-full sm:min-w-[444px] sm:max-w-[444px]"
  }, isDesktop && /*#__PURE__*/React.createElement(PaymentInfo, {
    loading: fetch_loading || !checkoutOrder,
    checkoutOrder: checkoutOrder,
    className: "border-none md:rounded-xl md:border md:border-solid md:border-[#EBF0F7]",
    hideData: true,
    onClickInfoIcon: onInfoIconClick,
    showWarrantyWidget: isDesktop && !isOtpStep,
    orderType: "tabby",
    onWarrantySelected: function onWarrantySelected(id) {
      return void (remote_actions === null || remote_actions === void 0 ? void 0 : remote_actions.fetch__getOrderDetailsByParams({
        warranty_id: id,
        city_id: String((userInfo === null || userInfo === void 0 ? void 0 : userInfo.city_id) || "")
      }));
    }
  }))));
};
export default TabbyFormContent;